import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getPasswordRecoveryState,
} from '../../../store/reducers';
import * as RecoveryMethodsActions from '../../store/actions/password-recovery-management.actions';
import { PasswordRecoveryManagementState } from '../../store/reducers/password-recovery-management.reducer';

@Component({
  selector: 'mprd-email-pending-container',
  templateUrl: 'email-pending-container.component.html',
})
export class EmailPendingContainerComponent implements OnInit {
  pendingMailId: string;
  showChangeEmailId = false;

  constructor(private store: Store<ApplicationState>) {}

  ngOnInit() {
    this.store
      .select(getPasswordRecoveryState)
      .subscribe(
        (passwordRecoveryManagementState: PasswordRecoveryManagementState) => {
          if (
            passwordRecoveryManagementState.passwordRecoveryManagement &&
            passwordRecoveryManagementState.passwordRecoveryManagement.email
          ) {
            this.pendingMailId =
              passwordRecoveryManagementState.passwordRecoveryManagement.email.mail;
          }
        },
      );
  }

  setEmailRecovery(emailId = this.pendingMailId) {
    this.store.dispatch(
      new RecoveryMethodsActions.SetEmailRecoveryMethodAction(emailId),
    );
  }

  onValidEmailSubmit(emailId: string) {
    this.showChangeEmailId = false;
    this.setEmailRecovery(emailId);
  }

  onEmailSubmitCancel() {
    this.showChangeEmailId = !this.showChangeEmailId;
  }
}
